<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="面经题目"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.organization"
              label="企业名称"
              single
              :messages="message"
              :error="!!error.organizationErrors.length"
              :error-messages="error.organizationErrors"
              :options="organizations.map(x=>x.name)"
              searchable
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.positionTag"
              label="职位类型"
              :messages="message"
              :error="!!error.positionTagsErrors.length"
              :error-messages="error.positionTagsErrors"
              :options="positionTags.map(x=>x.name)"
              :onchange="handlePositionTagIdChange"
              searchable
            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.positionTag!==''">
            <va-select
              v-model="insertData.questionTags"
              label="题目类型"
              multiple
              searchable
              :messages="message"
              :error="!!error.questionTagsErrors.length"
              :error-messages="error.questionTagsErrors"
              :options="questionTags.map(x=>x.name)"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.content"
              placeholder="面经内容"
              :config="captionConfig"
              @trix-attachment-add="handleAttachmentChanges"
            ></vue-trix>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="发布状态"
              single
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
              :options="statusOptions"
            />
          </div>
        </div>

        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '@/utils/common'
import uploadApi from '../../api/upload'
import organizationApi from '../../api/organization'
import interviewQuestionApi from '../../api/interview/interviewQuestion'
import { STATUS_OPTIONS, INTERVIEW_TAG_TYPE } from '@/utils/constants'
import questionTagApi from '../../api/interview/questionTag'
import positionTagApi from '@/api/interview/positionTag'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        content: '',
        sortNum: 1,
        createdAt: '',
        questionTagIds: [],
        questionTags: [],
        positionTagId: null,
        positionTag: '',
        organization: '',
        organizationId: null,
        status: '草稿中',
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        sortNumErrors: [],
        questionTagsErrors: [],
        positionTagsErrors: [],
        statusErrors: [],
        organizationErrors: [],
      },
      showId: false,
      title: '创建面经',
      submitButtonStatus: true,
      statusOptions: STATUS_OPTIONS.map(x => x.TEXT),
      questionTags: [],
      organizations: [],
      positionTags: [],
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    this.listPositionTag()
    this.listOrganization()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.organizationErrors.length &&
          !this.error.questionTagsErrors.length &&
          !this.error.positionTagsErrors.length &&
          !this.error.statusErrors.length
    },
    flipOrganization () {
      const flipTags = {}
      this.organizations.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipPositionTags () {
      const flipTags = {}
      this.positionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipQuestionTags () {
      const flipTags = {}
      this.questionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    handlePositionTagIdChange () {
      this.listQuestionTag()
      return true
    },
  },
  methods: {
    getInterviewQuestion () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑面经'
        // 通过id获取详情
        interviewQuestionApi.getInterviewQuestion(params.id).then(response => {
          copyObject(response.interviewQuestion, this.insertData)
          this.listQuestionTag()
          STATUS_OPTIONS.forEach(x => {
            if (x.CODE === response.interviewQuestion.status) {
              this.insertData.status = x.TEXT
            }
          })
          this.insertData.questionTags = response.interviewQuestion.questionTags
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listPositionTag () {
      const params = {
        type: INTERVIEW_TAG_TYPE.POSITION_TAG.CODE,
      }
      positionTagApi.listPositionTag(params).then(response => {
        this.positionTags = response.tags
        this.getInterviewQuestion()
      }).catch(error => this.showToast('获取职位失败: ' + error.msg, {
        duration: 1000,
        icon: 'fa-check',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    listQuestionTag () {
      const params = {
        type: INTERVIEW_TAG_TYPE.QUESTION_TAG.CODE,
        positionTagId: this.flipPositionTags[this.insertData.positionTag],
      }
      questionTagApi.listQuestionTag(params).then(response => {
        this.questionTags = response.tags
      }).catch(error => alert(error.msg))
    },
    listOrganization () {
      const params = {
        pageNumber: 1,
        pageSize: 10000,
      }
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
      }).catch(error => alert(error.msg))
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        content: this.insertData.content,
        questionTagIds: [],
        organizationId: null,
        status: null,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      data.positionTagId = this.flipPositionTags[this.insertData.positionTag]
      data.organizationId = this.flipOrganization[this.insertData.organization]
      data.questionTagIds = this.insertData.questionTags.map(x => {
        return this.flipQuestionTags[x]
      }).filter(Boolean)
      STATUS_OPTIONS.forEach(x => {
        if (x.TEXT === this.insertData.status) {
          data.status = x.CODE
        }
      })

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        interviewQuestionApi.updateInterviewQuestion(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('面经更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listInterviewQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        interviewQuestionApi.saveInterviewQuestion(data).then(response => {
          if (response.success === true) {
            this.showToast('添加面经成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listInterviewQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.organizationErrors = this.insertData.organization ? [] : ['organization is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.questionTagsErrors = this.insertData.questionTags ? [] : ['questionTags is required']
      this.error.positionTagsErrors = this.insertData.positionTag ? [] : ['positionTag is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {console.log(error)
      })
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
